import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { datadogLogs } from '@datadog/browser-logs';
import { store } from './redux/store.ts';
import App from './App.tsx';
import { configs } from './constants/configs';

const persistor = persistStore(store);

if (configs.VITE_APP_CLUSTER === 'prod' && configs.VITE_APP_DATADOG_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: configs.VITE_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    sessionSampleRate: 100,
    env: `${configs.VITE_APP_CLUSTER}:react-admin`,
    service: 'fe-react-admin',
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
